'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { noTooltipInternal } from '../icon-button/icon-button-internal.utils.js';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';
import { useModalDialogContext } from './modal-dialog.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { IconButton } from '../icon-button/icon-button.component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';
import { Icon } from '../icon/icon.component.js';
import { className } from '../../../core/utilities/classnames.utils.js';

function _define_property(e, t, o) {
    return t in e ? Object.defineProperty(e, t, {
        value: o,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = o, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var o = null != arguments[t] ? arguments[t] : {}, r = Object.keys(o);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
            return Object.getOwnPropertyDescriptor(o, e).enumerable;
        }))), r.forEach(function(t) {
            _define_property(e, t, o[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var o = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        o.push.apply(o, r);
    }
    return o;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(o) {
        Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var o, r, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(r = 0; r < c.length; r++)o = c[r], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var o, r, n = {}, c = Object.keys(e);
    for(r = 0; r < c.length; r++)o = c[r], t.indexOf(o) >= 0 || (n[o] = e[o]);
    return n;
}
const ModalDialogCloseButton = renderWithRef('ModalDialogCloseButton', null, (o, m)=>{
    let f = useInternalOptionalSwanI18nContext();
    useDeprecatedProps('ModalDialogCloseButton', o, [
        {
            propName: 'visuallyHiddenLabel',
            instructions: getDeprecatedI18nPropMessage(f)
        },
        {
            propName: 'accessibleText',
            instructions: getDeprecatedI18nPropMessage(f)
        }
    ]);
    let { handleModalCloseButton: d } = useModalDialogContext(), { visuallyHiddenLabel: y, accessibleText: _, onClick: j, className: O, children: g } = o, w = _object_without_properties(o, [
        "visuallyHiddenLabel",
        "accessibleText",
        "onClick",
        "className",
        "children"
    ]), h = null != _ ? _ : y;
    return f && !h && (h = f.t('modal-dialog.close-button.accessible-text-for-icon')), jsxs(IconButton, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
        skin: "tertiary",
        className: className('swan-modal-dialog-close-button', O),
        ref: m
    }, w), {
        onClick: composeEventHandlersUtil(j, d),
        tooltip: ""
    }), noTooltipInternal), {
        children: [
            null !== h ? jsx(VisuallyHidden, {
                children: h
            }) : null,
            jsx(Icon, {
                iconType: "close",
                size: "standard"
            })
        ]
    }));
});

export { ModalDialogCloseButton };
